<template >
    <div>
        <!-- 年龄统计 -->
        <div v-if="chartType=='age'||chartType=='sex'" class="echart-statistics">
            <div  class="statistics-num">
                <span>总人数：<b>{{statisticsData.personNum}}</b></span>
                <!-- <div class="statistics-num">{{statisticsData.personNum}}</div> -->
                <!-- <el-input class="num-input" disabled size='mini'   v-model="statisticsData.personNum" :min="1" :max="100" label=""></el-input> -->
            </div>
            <div class="statistics-num">
                <span>总案例数：<b>{{statisticsData.totalDataNum}}</b></span>
                <!-- <el-input class="num-input" disabled size='mini'   v-model="statisticsData.totalDataNum" :min="1" :max="100" label=""></el-input> -->
            </div>
            <div v-if="chartType=='age'" class="statistics-num">
                <span>平均年龄：<b>{{statisticsData.ageAvg}}</b></span>
                <!-- <el-input class="num-input" disabled size='mini'   v-model="statisticsData.ageAvg" :min="1" :max="100" label=""></el-input> -->
            </div>
        </div>
        <div v-else class="echart-statistics">
            <div class="statistics-num">
                <span>统计个数：<b v-if="isTcm">{{statisticsData.selsectNum}}</b></span>
                <!--  中药属性的里的四气五味归经不可修改统计个数 -->
                <el-input-number v-if='!isTcm' class="num-input-number" @change="modify_num" size='mini'  v-model="statisticsData.selsectNum" :min="1" :max="100" label=""></el-input-number>
            </div>
            <div  class="statistics-num">
                <span>{{chartName}}数量：<b>{{statisticsData.totalSelectNum}}</b></span>
                <!-- <el-input class="num-input" disabled size='mini'   v-model="statisticsData.totalSelectNum" :min="1" :max="100" label=""></el-input> -->
            </div>
            <!-- 只有中药属性的里的四个选项显示 -->
            <div v-if="chartType=='four'||chartType=='five'||chartType=='tropism' ||chartType=='effect'" class="statistics-num">
                <span>总中药数：<b>{{statisticsData.tcmList}}</b></span>
                <!-- <el-input class="num-input" disabled size='mini'   v-model="statisticsData.tcmList" :min="1" :max="100" label=""></el-input> -->
            </div>
            <div v-if="isLocation" class="statistics-num">
                <span>总证侯数：<b>{{statisticsData.tcsyNum}}</b></span>
                <!-- <el-input class="num-input" disabled size='mini'   v-model="statisticsData.tcsyNum" :min="1" :max="100" label=""></el-input> -->
            </div>
            <div  class="statistics-num">
                <span>总频次：<b>{{statisticsData.totalRateNum}}</b></span>
                <!-- <el-input class="num-input" disabled size='mini'   v-model="statisticsData.totalRateNum" :min="1" :max="100" label=""></el-input> -->
            </div>
            <div  class="statistics-num">
                <span>总案例数：<b>{{statisticsData.totalDataNum}}</b></span>
                <!-- <el-input class="num-input" disabled size="mini"   v-model="statisticsData.totalDataNum" :min="1" :max="100" label=""></el-input> -->
            </div>
        </div>
    </div>
    
</template>
<script>

import {mapState,mapMutations,mapActions} from 'vuex'
export default {
    
    // props:['statisticsData'],
    computed: {
        ...mapState({
            statisticsData:state=>state.excavate.statisticsData,
            chartType:state=>state.excavate.chartType,
            isTcm:state=>state.excavate.isTcm,
            isLocation:state=>state.excavate.isLocation,
            chartName:state=>state.excavate.chartName,
        })
    },
    methods: {
        modify_num(val){
            this.$store.state.excavate.statisticsData.selsectNum = val;
            this.$emit('modify_num',val)
        }
    },
}
</script>
<style lang="">
    
</style>